var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboPauseCircleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.33333C11.1267 2.33333 13.6667 4.87333 13.6667 8C13.6667 11.1267 11.1267 13.6667 8 13.6667C4.87333 13.6667 2.33333 11.1267 2.33333 8C2.33333 4.87333 4.87333 2.33333 8 2.33333ZM8 1C4.13333 1 1 4.13333 1 8C1 11.8667 4.13333 15 8 15C11.8667 15 15 11.8667 15 8C15 4.13333 11.8667 1 8 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.33301H6.33333C6.14924 5.33301 6 5.48225 6 5.66634V10.333C6 10.5171 6.14924 10.6663 6.33333 10.6663H7C7.18409 10.6663 7.33333 10.5171 7.33333 10.333V5.66634C7.33333 5.48225 7.18409 5.33301 7 5.33301Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66602 5.33301H8.99935C8.81525 5.33301 8.66602 5.48225 8.66602 5.66634V10.333C8.66602 10.5171 8.81525 10.6663 8.99935 10.6663H9.66602C9.85011 10.6663 9.99935 10.5171 9.99935 10.333V5.66634C9.99935 5.48225 9.85011 5.33301 9.66602 5.33301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboPauseCircleSmall);
export default __webpack_public_path__ + "static/media/FBOPauseCircleSmall.7620dde905355a28808d6d8a53fd73b2.svg";
export { ForwardRef as ReactComponent };